import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ICONS } from 'src/app/core/constants/icons';

@Component({
  selector: 'terms-and-conditions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
})
export class TermsAndConditionsComponent {
  protected isTermsExpanded: boolean = false;
  protected isPrivacyExpanded: boolean = false;
  protected WHITE_ARROW_DOWN = ICONS.WHITE_ARROW_DOWN;

  constructor() {}

  toggleTerms() {
    this.isTermsExpanded = !this.isTermsExpanded;
    this.isPrivacyExpanded = false;
  }
  
  togglePrivacy() {
    this.isPrivacyExpanded = !this.isPrivacyExpanded;
    this.isTermsExpanded = false;
  }
}